const Natural = [
    {
        "identifier": "20210626004554",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626004554.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.112793,
            "lon": 162.546387
        },
        "dscovr_j2000_position": {
            "x": 54029.908752,
            "y": 1505511.438125,
            "z": 493694.603125
        },
        "lunar_j2000_position": {
            "x": 134539.761915,
            "y": -302563.631983,
            "z": -155250.100487
        },
        "sun_j2000_position": {
            "x": -11573022.240418,
            "y": 139114644.867204,
            "z": 60305482.800002
        },
        "attitude_quaternions": {
            "q0": -0.57512,
            "q1": 0.69125,
            "q2": -0.19802,
            "q3": 0.39013
        },
        "date": "2021-06-26 00:41:06",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.112793,
                "lon": 162.546387
            },
            "dscovr_j2000_position": {
                "x": 54029.908752,
                "y": 1505511.438125,
                "z": 493694.603125
            },
            "lunar_j2000_position": {
                "x": 134539.761915,
                "y": -302563.631983,
                "z": -155250.100487
            },
            "sun_j2000_position": {
                "x": -11573022.240418,
                "y": 139114644.867204,
                "z": 60305482.800002
            },
            "attitude_quaternions": {
                "q0": -0.57512,
                "q1": 0.69125,
                "q2": -0.19802,
                "q3": 0.39013
            }
        }
    },
    {
        "identifier": "20210626015122",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626015122.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.061523,
            "lon": 146.162109
        },
        "dscovr_j2000_position": {
            "x": 53218.251,
            "y": 1505550.961016,
            "z": 493557.975191
        },
        "lunar_j2000_position": {
            "x": 138514.504687,
            "y": -301147.342943,
            "z": -154962.872454
        },
        "sun_j2000_position": {
            "x": -11687706.599807,
            "y": 139106850.584812,
            "z": 60302099.400006
        },
        "attitude_quaternions": {
            "q0": -0.57521,
            "q1": 0.69098,
            "q2": -0.19831,
            "q3": 0.39033
        },
        "date": "2021-06-26 01:46:33",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.061523,
                "lon": 146.162109
            },
            "dscovr_j2000_position": {
                "x": 53218.251,
                "y": 1505550.961016,
                "z": 493557.975191
            },
            "lunar_j2000_position": {
                "x": 138514.504687,
                "y": -301147.342943,
                "z": -154962.872454
            },
            "sun_j2000_position": {
                "x": -11687706.599807,
                "y": 139106850.584812,
                "z": 60302099.400006
            },
            "attitude_quaternions": {
                "q0": -0.57521,
                "q1": 0.69098,
                "q2": -0.19831,
                "q3": 0.39033
            }
        }
    },
    {
        "identifier": "20210626025650",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626025650.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.105469,
            "lon": 129.770508
        },
        "dscovr_j2000_position": {
            "x": 52405.843879,
            "y": 1505590.385417,
            "z": 493421.590353
        },
        "lunar_j2000_position": {
            "x": 142472.638848,
            "y": -299692.790646,
            "z": -154656.039383
        },
        "sun_j2000_position": {
            "x": -11802414.20819,
            "y": 139098974.015033,
            "z": 60298683.133329
        },
        "attitude_quaternions": {
            "q0": -0.57527,
            "q1": 0.69072,
            "q2": -0.19853,
            "q3": 0.39058
        },
        "date": "2021-06-26 02:52:01",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.105469,
                "lon": 129.770508
            },
            "dscovr_j2000_position": {
                "x": 52405.843879,
                "y": 1505590.385417,
                "z": 493421.590353
            },
            "lunar_j2000_position": {
                "x": 142472.638848,
                "y": -299692.790646,
                "z": -154656.039383
            },
            "sun_j2000_position": {
                "x": -11802414.20819,
                "y": 139098974.015033,
                "z": 60298683.133329
            },
            "attitude_quaternions": {
                "q0": -0.57527,
                "q1": 0.69072,
                "q2": -0.19853,
                "q3": 0.39058
            }
        }
    },
    {
        "identifier": "20210626040217",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626040217.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.054199,
            "lon": 113.371582
        },
        "dscovr_j2000_position": {
            "x": 51593.097657,
            "y": 1505629.532449,
            "z": 493285.523178
        },
        "lunar_j2000_position": {
            "x": 146411.663375,
            "y": -298200.983647,
            "z": -154329.816601
        },
        "sun_j2000_position": {
            "x": -11917085.599885,
            "y": 139091029.399396,
            "z": 60295231.477688
        },
        "attitude_quaternions": {
            "q0": -0.575256,
            "q1": 0.690507,
            "q2": -0.198676,
            "q3": 0.390904
        },
        "date": "2021-06-26 03:57:28",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.054199,
                "lon": 113.371582
            },
            "dscovr_j2000_position": {
                "x": 51593.097657,
                "y": 1505629.532449,
                "z": 493285.523178
            },
            "lunar_j2000_position": {
                "x": 146411.663375,
                "y": -298200.983647,
                "z": -154329.816601
            },
            "sun_j2000_position": {
                "x": -11917085.599885,
                "y": 139091029.399396,
                "z": 60295231.477688
            },
            "attitude_quaternions": {
                "q0": -0.575256,
                "q1": 0.690507,
                "q2": -0.198676,
                "q3": 0.390904
            }
        }
    },
    {
        "identifier": "20210626050744",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626050744.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.098145,
            "lon": 97.038574
        },
        "dscovr_j2000_position": {
            "x": 50779.590356,
            "y": 1505668.463671,
            "z": 493149.699936
        },
        "lunar_j2000_position": {
            "x": 150333.101569,
            "y": -296671.409856,
            "z": -153984.119355
        },
        "sun_j2000_position": {
            "x": -12031779.200051,
            "y": 139082984.037764,
            "z": 60291747.578511
        },
        "attitude_quaternions": {
            "q0": -0.57537,
            "q1": 0.69022,
            "q2": -0.19895,
            "q3": 0.39111
        },
        "date": "2021-06-26 05:02:56",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.098145,
                "lon": 97.038574
            },
            "dscovr_j2000_position": {
                "x": 50779.590356,
                "y": 1505668.463671,
                "z": 493149.699936
            },
            "lunar_j2000_position": {
                "x": 150333.101569,
                "y": -296671.409856,
                "z": -153984.119355
            },
            "sun_j2000_position": {
                "x": -12031779.200051,
                "y": 139082984.037764,
                "z": 60291747.578511
            },
            "attitude_quaternions": {
                "q0": -0.57537,
                "q1": 0.69022,
                "q2": -0.19895,
                "q3": 0.39111
            }
        }
    },
    {
        "identifier": "20210626061312",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626061312.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.07251,
            "lon": 80.57373
        },
        "dscovr_j2000_position": {
            "x": 49965.730903,
            "y": 1505707.194731,
            "z": 493014.198264
        },
        "lunar_j2000_position": {
            "x": 154234.50715,
            "y": -295105.097,
            "z": -153619.183337
        },
        "sun_j2000_position": {
            "x": -12146437.244151,
            "y": 139074880.177271,
            "z": 60288223.96044
        },
        "attitude_quaternions": {
            "q0": -0.575348,
            "q1": 0.690014,
            "q2": -0.199087,
            "q3": 0.391426
        },
        "date": "2021-06-26 06:08:23",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.07251,
                "lon": 80.57373
            },
            "dscovr_j2000_position": {
                "x": 49965.730903,
                "y": 1505707.194731,
                "z": 493014.198264
            },
            "lunar_j2000_position": {
                "x": 154234.50715,
                "y": -295105.097,
                "z": -153619.183337
            },
            "sun_j2000_position": {
                "x": -12146437.244151,
                "y": 139074880.177271,
                "z": 60288223.96044
            },
            "attitude_quaternions": {
                "q0": -0.575348,
                "q1": 0.690014,
                "q2": -0.199087,
                "q3": 0.391426
            }
        }
    },
    {
        "identifier": "20210626071839",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626071839.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.061523,
            "lon": 64.226074
        },
        "dscovr_j2000_position": {
            "x": 49151.097678,
            "y": 1505745.654922,
            "z": 492878.934375
        },
        "lunar_j2000_position": {
            "x": 158117.381647,
            "y": -293501.506237,
            "z": -153234.905048
        },
        "sun_j2000_position": {
            "x": -12261117.305345,
            "y": 139066675.200003,
            "z": 60284668.439668
        },
        "attitude_quaternions": {
            "q0": -0.57541,
            "q1": 0.68975,
            "q2": -0.19933,
            "q3": 0.39169
        },
        "date": "2021-06-26 07:13:51",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.061523,
                "lon": 64.226074
            },
            "dscovr_j2000_position": {
                "x": 49151.097678,
                "y": 1505745.654922,
                "z": 492878.934375
            },
            "lunar_j2000_position": {
                "x": 158117.381647,
                "y": -293501.506237,
                "z": -153234.905048
            },
            "sun_j2000_position": {
                "x": -12261117.305345,
                "y": 139066675.200003,
                "z": 60284668.439668
            },
            "attitude_quaternions": {
                "q0": -0.57541,
                "q1": 0.68975,
                "q2": -0.19933,
                "q3": 0.39169
            }
        }
    },
    {
        "identifier": "20210626082407",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626082407.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.061523,
            "lon": 47.900391
        },
        "dscovr_j2000_position": {
            "x": 48336.102734,
            "y": 1505783.904667,
            "z": 492743.983072
        },
        "lunar_j2000_position": {
            "x": 161979.317937,
            "y": -291861.704986,
            "z": -152831.588916
        },
        "sun_j2000_position": {
            "x": -12375761.55803,
            "y": 139058409.599997,
            "z": 60281079.504888
        },
        "attitude_quaternions": {
            "q0": -0.57551,
            "q1": 0.6895,
            "q2": -0.19954,
            "q3": 0.39187
        },
        "date": "2021-06-26 08:19:18",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.061523,
                "lon": 47.900391
            },
            "dscovr_j2000_position": {
                "x": 48336.102734,
                "y": 1505783.904667,
                "z": 492743.983072
            },
            "lunar_j2000_position": {
                "x": 161979.317937,
                "y": -291861.704986,
                "z": -152831.588916
            },
            "sun_j2000_position": {
                "x": -12375761.55803,
                "y": 139058409.599997,
                "z": 60281079.504888
            },
            "attitude_quaternions": {
                "q0": -0.57551,
                "q1": 0.6895,
                "q2": -0.19954,
                "q3": 0.39187
            }
        }
    },
    {
        "identifier": "20210626092934",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626092934.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.039551,
            "lon": 31.464844
        },
        "dscovr_j2000_position": {
            "x": 47520.527161,
            "y": 1505821.85026,
            "z": 492609.328863
        },
        "lunar_j2000_position": {
            "x": 165820.842387,
            "y": -290185.587494,
            "z": -152409.17425
        },
        "sun_j2000_position": {
            "x": -12490399.273424,
            "y": 139050048.000001,
            "z": 60277454
        },
        "attitude_quaternions": {
            "q0": -0.57547,
            "q1": 0.68929,
            "q2": -0.19968,
            "q3": 0.392225
        },
        "date": "2021-06-26 09:24:45",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.039551,
                "lon": 31.464844
            },
            "dscovr_j2000_position": {
                "x": 47520.527161,
                "y": 1505821.85026,
                "z": 492609.328863
            },
            "lunar_j2000_position": {
                "x": 165820.842387,
                "y": -290185.587494,
                "z": -152409.17425
            },
            "sun_j2000_position": {
                "x": -12490399.273424,
                "y": 139050048.000001,
                "z": 60277454
            },
            "attitude_quaternions": {
                "q0": -0.57547,
                "q1": 0.68929,
                "q2": -0.19968,
                "q3": 0.392225
            }
        }
    },
    {
        "identifier": "20210626103501",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626103501.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.039551,
            "lon": 15.095215
        },
        "dscovr_j2000_position": {
            "x": 46704.16412,
            "y": 1505859.613676,
            "z": 492474.896296
        },
        "lunar_j2000_position": {
            "x": 169642.456622,
            "y": -288472.994396,
            "z": -151967.678135
        },
        "sun_j2000_position": {
            "x": -12605058.551923,
            "y": 139041603.265637,
            "z": 60273791.866666
        },
        "attitude_quaternions": {
            "q0": -0.57555,
            "q1": 0.689036,
            "q2": -0.199891,
            "q3": 0.392437
        },
        "date": "2021-06-26 10:30:13",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.039551,
                "lon": 15.095215
            },
            "dscovr_j2000_position": {
                "x": 46704.16412,
                "y": 1505859.613676,
                "z": 492474.896296
            },
            "lunar_j2000_position": {
                "x": 169642.456622,
                "y": -288472.994396,
                "z": -151967.678135
            },
            "sun_j2000_position": {
                "x": -12605058.551923,
                "y": 139041603.265637,
                "z": 60273791.866666
            },
            "attitude_quaternions": {
                "q0": -0.57555,
                "q1": 0.689036,
                "q2": -0.199891,
                "q3": 0.392437
            }
        }
    },
    {
        "identifier": "20210626114028",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626114028.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.017578,
            "lon": -1.252441
        },
        "dscovr_j2000_position": {
            "x": 45887.419414,
            "y": 1505897.046811,
            "z": 492340.780084
        },
        "lunar_j2000_position": {
            "x": 173441.799276,
            "y": -286725.007099,
            "z": -151507.38768
        },
        "sun_j2000_position": {
            "x": -12719682.037265,
            "y": 139033098.666651,
            "z": 60270095.846736
        },
        "attitude_quaternions": {
            "q0": -0.57566,
            "q1": 0.68875,
            "q2": -0.20017,
            "q3": 0.39265
        },
        "date": "2021-06-26 11:35:40",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.017578,
                "lon": -1.252441
            },
            "dscovr_j2000_position": {
                "x": 45887.419414,
                "y": 1505897.046811,
                "z": 492340.780084
            },
            "lunar_j2000_position": {
                "x": 173441.799276,
                "y": -286725.007099,
                "z": -151507.38768
            },
            "sun_j2000_position": {
                "x": -12719682.037265,
                "y": 139033098.666651,
                "z": 60270095.846736
            },
            "attitude_quaternions": {
                "q0": -0.57566,
                "q1": 0.68875,
                "q2": -0.20017,
                "q3": 0.39265
            }
        }
    },
    {
        "identifier": "20210626124556",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626124556.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.024902,
            "lon": -17.629395
        },
        "dscovr_j2000_position": {
            "x": 45070.077736,
            "y": 1505934.19243,
            "z": 492206.950708
        },
        "lunar_j2000_position": {
            "x": 177220.337365,
            "y": -284941.084978,
            "z": -151028.143798
        },
        "sun_j2000_position": {
            "x": -12834298.328608,
            "y": 139024497.066683,
            "z": 60266365.290887
        },
        "attitude_quaternions": {
            "q0": -0.57566,
            "q1": 0.68853,
            "q2": -0.20033,
            "q3": 0.39295
        },
        "date": "2021-06-26 12:41:07",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.024902,
                "lon": -17.629395
            },
            "dscovr_j2000_position": {
                "x": 45070.077736,
                "y": 1505934.19243,
                "z": 492206.950708
            },
            "lunar_j2000_position": {
                "x": 177220.337365,
                "y": -284941.084978,
                "z": -151028.143798
            },
            "sun_j2000_position": {
                "x": -12834298.328608,
                "y": 139024497.066683,
                "z": 60266365.290887
            },
            "attitude_quaternions": {
                "q0": -0.57566,
                "q1": 0.68853,
                "q2": -0.20033,
                "q3": 0.39295
            }
        }
    },
    {
        "identifier": "20210626135124",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626135124.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.024902,
            "lon": -34.006348
        },
        "dscovr_j2000_position": {
            "x": 44251.931068,
            "y": 1505971.164416,
            "z": 492073.346354
        },
        "lunar_j2000_position": {
            "x": 180975.7396,
            "y": -283122.399353,
            "z": -150530.32966
        },
        "sun_j2000_position": {
            "x": -12948936.467372,
            "y": 139015819.656856,
            "z": 60262600.916185
        },
        "attitude_quaternions": {
            "q0": -0.57568,
            "q1": 0.6883,
            "q2": -0.20045,
            "q3": 0.39326
        },
        "date": "2021-06-26 13:46:35",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.024902,
                "lon": -34.006348
            },
            "dscovr_j2000_position": {
                "x": 44251.931068,
                "y": 1505971.164416,
                "z": 492073.346354
            },
            "lunar_j2000_position": {
                "x": 180975.7396,
                "y": -283122.399353,
                "z": -150530.32966
            },
            "sun_j2000_position": {
                "x": -12948936.467372,
                "y": 139015819.656856,
                "z": 60262600.916185
            },
            "attitude_quaternions": {
                "q0": -0.57568,
                "q1": 0.6883,
                "q2": -0.20045,
                "q3": 0.39326
            }
        }
    },
    {
        "identifier": "20210626145651",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626145651.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.039551,
            "lon": -50.361328
        },
        "dscovr_j2000_position": {
            "x": 43433.38763,
            "y": 1506007.893337,
            "z": 491940.057292
        },
        "lunar_j2000_position": {
            "x": 184708.521759,
            "y": -281268.77003,
            "z": -150013.883613
        },
        "sun_j2000_position": {
            "x": -13063537.366642,
            "y": 139007067.454747,
            "z": 60258801.997779
        },
        "attitude_quaternions": {
            "q0": -0.575773,
            "q1": 0.68803,
            "q2": -0.200734,
            "q3": 0.393447
        },
        "date": "2021-06-26 14:52:02",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.039551,
                "lon": -50.361328
            },
            "dscovr_j2000_position": {
                "x": 43433.38763,
                "y": 1506007.893337,
                "z": 491940.057292
            },
            "lunar_j2000_position": {
                "x": 184708.521759,
                "y": -281268.77003,
                "z": -150013.883613
            },
            "sun_j2000_position": {
                "x": -13063537.366642,
                "y": 139007067.454747,
                "z": 60258801.997779
            },
            "attitude_quaternions": {
                "q0": -0.575773,
                "q1": 0.68803,
                "q2": -0.200734,
                "q3": 0.393447
            }
        }
    },
    {
        "identifier": "20210626160219",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626160219.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.017578,
            "lon": -66.730957
        },
        "dscovr_j2000_position": {
            "x": 42614.023439,
            "y": 1506044.243056,
            "z": 491807.015625
        },
        "lunar_j2000_position": {
            "x": 188419.199277,
            "y": -279380.045031,
            "z": -149478.76784
        },
        "sun_j2000_position": {
            "x": -13178160.999853,
            "y": 138998224.00001,
            "z": 60254965.741384
        },
        "attitude_quaternions": {
            "q0": -0.57581,
            "q1": 0.6878,
            "q2": -0.20088,
            "q3": 0.39374
        },
        "date": "2021-06-26 15:57:30",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.017578,
                "lon": -66.730957
            },
            "dscovr_j2000_position": {
                "x": 42614.023439,
                "y": 1506044.243056,
                "z": 491807.015625
            },
            "lunar_j2000_position": {
                "x": 188419.199277,
                "y": -279380.045031,
                "z": -149478.76784
            },
            "sun_j2000_position": {
                "x": -13178160.999853,
                "y": 138998224.00001,
                "z": 60254965.741384
            },
            "attitude_quaternions": {
                "q0": -0.57581,
                "q1": 0.6878,
                "q2": -0.20088,
                "q3": 0.39374
            }
        }
    },
    {
        "identifier": "20210626170747",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626170747.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.028564,
            "lon": -83.166504
        },
        "dscovr_j2000_position": {
            "x": 41794.042647,
            "y": 1506080.481255,
            "z": 491674.223958
        },
        "lunar_j2000_position": {
            "x": 192106.408889,
            "y": -277456.943609,
            "z": -148925.218143
        },
        "sun_j2000_position": {
            "x": -13292776.651659,
            "y": 138989300.809096,
            "z": 60251097.92474
        },
        "attitude_quaternions": {
            "q0": -0.57584,
            "q1": 0.68756,
            "q2": -0.20109,
            "q3": 0.394
        },
        "date": "2021-06-26 17:02:58",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.028564,
                "lon": -83.166504
            },
            "dscovr_j2000_position": {
                "x": 41794.042647,
                "y": 1506080.481255,
                "z": 491674.223958
            },
            "lunar_j2000_position": {
                "x": 192106.408889,
                "y": -277456.943609,
                "z": -148925.218143
            },
            "sun_j2000_position": {
                "x": -13292776.651659,
                "y": 138989300.809096,
                "z": 60251097.92474
            },
            "attitude_quaternions": {
                "q0": -0.57584,
                "q1": 0.68756,
                "q2": -0.20109,
                "q3": 0.394
            }
        }
    },
    {
        "identifier": "20210626181314",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626181314.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.017578,
            "lon": -99.51416
        },
        "dscovr_j2000_position": {
            "x": 40973.650391,
            "y": 1506116.257603,
            "z": 491541.749628
        },
        "lunar_j2000_position": {
            "x": 195768.807934,
            "y": -275500.299069,
            "z": -148353.494667
        },
        "sun_j2000_position": {
            "x": -13407356.562969,
            "y": 138980298.361663,
            "z": 60247191.000004
        },
        "attitude_quaternions": {
            "q0": -0.57586,
            "q1": 0.68734,
            "q2": -0.20124,
            "q3": 0.39427
        },
        "date": "2021-06-26 18:08:25",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.017578,
                "lon": -99.51416
            },
            "dscovr_j2000_position": {
                "x": 40973.650391,
                "y": 1506116.257603,
                "z": 491541.749628
            },
            "lunar_j2000_position": {
                "x": 195768.807934,
                "y": -275500.299069,
                "z": -148353.494667
            },
            "sun_j2000_position": {
                "x": -13407356.562969,
                "y": 138980298.361663,
                "z": 60247191.000004
            },
            "attitude_quaternions": {
                "q0": -0.57586,
                "q1": 0.68734,
                "q2": -0.20124,
                "q3": 0.39427
            }
        }
    },
    {
        "identifier": "20210626191841",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626191841.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 18.010254,
            "lon": -115.935059
        },
        "dscovr_j2000_position": {
            "x": 40152.424892,
            "y": 1506151.811609,
            "z": 491409.485735
        },
        "lunar_j2000_position": {
            "x": 199407.824026,
            "y": -273509.438889,
            "z": -147763.387323
        },
        "sun_j2000_position": {
            "x": -13521957.756411,
            "y": 138971216.799981,
            "z": 60243250.976722
        },
        "attitude_quaternions": {
            "q0": -0.575912,
            "q1": 0.687088,
            "q2": -0.201434,
            "q3": 0.394528
        },
        "date": "2021-06-26 19:13:53",
        "coords": {
            "centroid_coordinates": {
                "lat": 18.010254,
                "lon": -115.935059
            },
            "dscovr_j2000_position": {
                "x": 40152.424892,
                "y": 1506151.811609,
                "z": 491409.485735
            },
            "lunar_j2000_position": {
                "x": 199407.824026,
                "y": -273509.438889,
                "z": -147763.387323
            },
            "sun_j2000_position": {
                "x": -13521957.756411,
                "y": 138971216.799981,
                "z": 60243250.976722
            },
            "attitude_quaternions": {
                "q0": -0.575912,
                "q1": 0.687088,
                "q2": -0.201434,
                "q3": 0.394528
            }
        }
    },
    {
        "identifier": "20210626202409",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626202409.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 17.980957,
            "lon": -132.32666
        },
        "dscovr_j2000_position": {
            "x": 39330.770833,
            "y": 1506187.174897,
            "z": 491277.550935
        },
        "lunar_j2000_position": {
            "x": 203021.236681,
            "y": -271485.625819,
            "z": -147155.332852
        },
        "sun_j2000_position": {
            "x": -13636522.407397,
            "y": 138962065.254901,
            "z": 60239280.143369
        },
        "attitude_quaternions": {
            "q0": -0.575999,
            "q1": 0.686829,
            "q2": -0.20166,
            "q3": 0.39474
        },
        "date": "2021-06-26 20:19:20",
        "coords": {
            "centroid_coordinates": {
                "lat": 17.980957,
                "lon": -132.32666
            },
            "dscovr_j2000_position": {
                "x": 39330.770833,
                "y": 1506187.174897,
                "z": 491277.550935
            },
            "lunar_j2000_position": {
                "x": 203021.236681,
                "y": -271485.625819,
                "z": -147155.332852
            },
            "sun_j2000_position": {
                "x": -13636522.407397,
                "y": 138962065.254901,
                "z": 60239280.143369
            },
            "attitude_quaternions": {
                "q0": -0.575999,
                "q1": 0.686829,
                "q2": -0.20166,
                "q3": 0.39474
            }
        }
    },
    {
        "identifier": "20210626212937",
        "caption": "This image was taken by NASA's EPIC camera onboard the NOAA DSCOVR spacecraft",
        "image": "https://epic.gsfc.nasa.gov/archive/natural/2021/06/26/jpg/epic_1b_20210626212937.jpg",
        "version": "03",
        "centroid_coordinates": {
            "lat": 17.995605,
            "lon": -148.64502
        },
        "dscovr_j2000_position": {
            "x": 38508.484628,
            "y": 1506222.141667,
            "z": 491145.870263
        },
        "lunar_j2000_position": {
            "x": 206610.44459,
            "y": -269428.182171,
            "z": -146529.102673
        },
        "sun_j2000_position": {
            "x": -13751078.833308,
            "y": 138952815.200002,
            "z": 60235269.668111
        },
        "attitude_quaternions": {
            "q0": -0.576014,
            "q1": 0.686598,
            "q2": -0.20181,
            "q3": 0.395042
        },
        "date": "2021-06-26 21:24:47",
        "coords": {
            "centroid_coordinates": {
                "lat": 17.995605,
                "lon": -148.64502
            },
            "dscovr_j2000_position": {
                "x": 38508.484628,
                "y": 1506222.141667,
                "z": 491145.870263
            },
            "lunar_j2000_position": {
                "x": 206610.44459,
                "y": -269428.182171,
                "z": -146529.102673
            },
            "sun_j2000_position": {
                "x": -13751078.833308,
                "y": 138952815.200002,
                "z": 60235269.668111
            },
            "attitude_quaternions": {
                "q0": -0.576014,
                "q1": 0.686598,
                "q2": -0.20181,
                "q3": 0.395042
            }
        }
    }
]


export default Natural